import { Period } from '@/schema/legal_entity/payment_plan/conditions';
import { Payment_Reference_Type } from '@/schema/legal_entity/processing_details';

const countries = require('@/constants/countries.json');
const languages = require('@/constants/languages.json');
export default class TranslationHelper {
	/**
	 *
	 * @param tag
	 */
	static tag(i18n, tag) {
		switch (tag) {
			case 'PAYMENT_PLAN':
				return i18n.t('tags.PAYMENT_PLAN');
			case 'COLLECTION':
				return i18n.t('tags.COLLECTION');
			case 'INVOICE_DISPUTE':
				return i18n.t('invoice_dispute');
			default:
				return tag;
		}
	}

	static event_type(vue, channel, type) {
		return vue.$t(`eventInfo.${channel.toLowerCase()}.${type.toLowerCase()}`);
	}

	static note_category(vue, category) {
		switch (category) {
			case 'DISPUTE':
				return vue.$t('note_category.DISPUTE');
			case 'INCORRECT_NUMBER':
				return vue.$t('note_category.INCORRECT_NUMBER');
			case 'OTHER':
				return vue.$t('note_category.OTHER');
			case 'PAYMENT_PLAN':
				return vue.$t('note_category.PAYMENT_PLAN');
			case 'PAYMENT_PROMISE':
				return vue.$t('note_category.PAYMENT_PROMISE');
			case 'UNREACHABLE':
				return vue.$t('note_category.UNREACHABLE');
			case 'VOICEMAIL':
				return vue.$t('note_category.VOICEMAIL');
			case 'INBOUND':
				return vue.$t('note_category.INBOUND');
			default:
				return category;
		}
	}

	static iso_country_code(i18n, iso_country_code) {
		if (!iso_country_code || !countries[iso_country_code]) {
			return '';
		}
		return countries[iso_country_code][i18n.locale] || '';
	}

	/**
 	* @param {String} string
	*/
	static channel(i18n, string) {
		if (string === 'MAIL') {
			return i18n.t('byPostalMail');
		} else if (string === 'PHONE') {
			return i18n.t('phoneCall');
		} else if (string === 'NONE') {
			return i18n.t('NONE');
		} else if (string === 'EMAIL') {
			return 'Email';
		} else if (string === 'DOCCLE') {
			return 'Doccle';
		} else if (string === 'EBOX') {
			return 'eBox';
		} else if (string === 'OTHER') {
			return i18n.t('other');
		} else {
			return string;
		}
	}

	static action_and_note(i18n, action_and_note) {
		switch (action_and_note) {
			case 'NOTE':
				return i18n.t('action_and_note.NOTE');
			case 'PHONE':
				return i18n.t('action_and_note.PHONE');
			case 'EMAIL':
				return i18n.t('action_and_note.EMAIL');
			case 'MAIL':
				return i18n.t('action_and_note.MAIL');
			case 'SMS':
				return i18n.t('action_and_note.SMS');
			case 'INVOICE_DISPUTE':
				return i18n.t('action_and_note.INVOICE_DISPUTE');
			case 'NONE':
				return i18n.t('action_and_note.NONE');
			default:
				return action_and_note;
		}
	}

	static action_message_code(i18n, actionMessageCode) {
		switch (actionMessageCode) {
			case 'collection':
				return i18n.t('action_message_code.collection');
			case 'Collection':
				return i18n.t('action_message_code.collection');
			case 'collection+':
				return i18n.t('action_message_code.collection_plus');
			case 'communication':
				return i18n.t('action_message_code.communication');
			case 'credit_note':
				return i18n.t('action_message_code.credit_note');
			case 'credit_note_copy':
				return i18n.t('action_message_code.credit_note_copy');
			case 'dunning_reminder_1':
				return i18n.t('action_message_code.dunning_reminder_1');
			case 'dunning_reminder_2':
				return i18n.t('action_message_code.dunning_reminder_2');
			case 'dunning_reminder_3':
				return i18n.t('action_message_code.dunning_reminder_3');
			case 'First Reminder':
				return i18n.t('action_message_code.first_reminder');
			case 'Second Reminder':
				return i18n.t('action_message_code.second_reminder');
			case 'Registered Mail':
				return i18n.t('action_message_code.registered_mail');
			case 'Payment Promise Pre Reminder':
				return i18n.t('action_message_code.payment_promise_pre_reminder');
			case 'Payment Promise Reminder':
				return i18n.t('action_message_code.payment_promise_reminder');
			case 'invoice':
				return i18n.t('action_message_code.invoice');
			case 'Invoice Copy':
				return i18n.t('action_message_code.invoice_copy');
			case 'invoiceCopy':
				return i18n.t('action_message_code.invoice_copy');
			case 'invoice_group_copy':
				return i18n.t('action_message_code.invoice_group_copy');
			case 'account_overview':
				return i18n.t('action_message_code.account_overview');
			case 'Account Overview':
				return i18n.t('action_message_code.account_overview');
			case 'scheduled manual action':
				return i18n.t('action_message_code.scheduled_manual_action');
			case 'payment_plan_new':
				return i18n.t('action_message_code.payment_plan_new');
			case 'direct_debit':
				return i18n.t('action_message_code.direct_debit');
			case 'key_account_overview':
				return i18n.t('action_message_code.key_account_overview');
			default:
				return actionMessageCode;
		}
	}

	/**
	 *
	 * @param actionStatus
	 */
	static action_status(i18n, actionStatus) {
		switch (actionStatus) {
			case 'OPEN':
				return i18n.t('action_status.OPEN');
			case 'DONE':
				return i18n.t('action_status.DONE');
			case 'DRAFT':
				return i18n.t('action_status.DRAFT');
			case 'CANCELED':
				return i18n.t('action_status.CANCELED');
			case 'PROCESSING':
				return i18n.t('action_status.PROCESSING');
			case 'SCHEDULED':
				return i18n.t('action_status.SCHEDULED');
			case 'FAILED':
				return i18n.t('action_status.FAILED');
			default:
				return actionStatus;
		}
	}

	static invoice_status(i18n, value) {
		if (value === 'PAID') {
			return i18n.t('paid');
		} else if (value === 'OVERDUE') {
			return i18n.t('overdue');
		} else if (value === 'OPEN') {
			return i18n.t('open');
		} else if (value === 'CLOSED') {
			return i18n.t('closed');
		} else if (value === 'LOADED') {
			return i18n.t('loaded');
		} else if (value === 'READY_FOR_SUBMISSION') {
			return i18n.t('readyForSubmission');
		} else if (value === 'PARSED') {
			return i18n.t('parsed');
		} else if (value === 'FAILED') {
			return i18n.t('failed');
		} else if (value === 'IN_REVIEW') {
			return i18n.t('inReview');
		} else {
			return 'info';
		}
	}

	static payment_plan_status(i18n, value) {
		switch (value) {
			case 'OPEN':
				return i18n.t('payment_plan.status.OPEN');
			case 'PAID':
				return i18n.t('payment_plan.status.PAID');
			case 'CANCELED_BY_USER':
				return i18n.t('payment_plan.status.CANCELED_BY_USER');
			case 'AUTO_CANCELED_BY_DUNNING':
				return i18n.t('payment_plan.status.AUTO_CANCELED_BY_DUNNING');
			case 'ABORTED':
				return i18n.t('payment_plan.status.ABORTED');
			default:
				return value;
		}
	}

	static language(i18n, language) {
		language = language.substring(0, 2);
		switch (language.toUpperCase()) {
			case 'NL':
				return i18n.t('languages.NL');
			case 'FR':
				return i18n.t('languages.FR');
			case 'EN':
				return i18n.t('languages.EN');
			case 'DE':
				return i18n.t('languages.DE');
			default:
				return language;
		}
	}

	/**
	 *
	 * @param i18n
	 * @param dispute_code
	 */
	static dispute_code(i18n, dispute_code) {
		switch (dispute_code) {
			case 'INCORRECT_INVOICE':
				return i18n.t('dispute_code.INCORRECT_INVOICE');
			case 'COMMERCIAL':
				return i18n.t('dispute_code.COMMERCIAL');
			case 'UNSATISFIED_CUSTOMER':
				return i18n.t('dispute_code.UNSATISFIED_CUSTOMER');
			case 'PAYMENT_NOT_PROCESSED':
				return i18n.t('dispute_code.PAYMENT_NOT_PROCESSED');
			case 'LEGAL':
				return i18n.t('dispute_code.LEGAL');
			case 'PAYMENT_PROMISE':
				return i18n.t('dispute_code.PAYMENT_PROMISE');
			case 'OTHER':
				return i18n.t('dispute_code.OTHER');
			default:
				try {
					const i18nCode = `dispute_code.${dispute_code}`;
					if (i18n.te(i18nCode)) {
						return i18n.t(i18nCode);
					}
					return dispute_code;
				} catch (e) {
					return dispute_code;
				}
		}
	}

	static template_id(i18n, template_id) {
		switch (template_id) {
			case 'account_overview':
				return i18n.t('template_id.account_overview');
			case 'collection_update':
				return i18n.t('template_id.collection_update');
			case 'credit_note':
				return i18n.t('template_id.credit_note');
			case 'dunning_collection':
				return i18n.t('template_id.dunning_collection');
			case 'dunning_first_reminder':
				return i18n.t('template_id.dunning_first_reminder');
			case 'dunning_reminder_call':
				return i18n.t('template_id.dunning_reminder_call');
			case 'dunning_reminder_sms':
				return i18n.t('template_id.dunning_reminder_sms');
			case 'dunning_second_reminder':
				return i18n.t('template_id.dunning_second_reminder');
			case 'invoice':
				return i18n.t('template_id.invoice');
			case 'payment_plan_new':
				return i18n.t('template_id.payment_plan_new');
			case 'payment_plan_pre_reminder':
				return i18n.t('template_id.payment_plan_pre_reminder');
			case 'payment_plan_reminder':
				return i18n.t('template_id.payment_plan_reminder');
			default:
				return template_id;
		}
	}

	static tone_of_voice(i18n, tone_of_voice) {
		switch (tone_of_voice) {
			case 'FRIENDLY':
				return i18n.t('tone_of_voice.FRIENDLY');
			default:
				return tone_of_voice;
		}
	}

	static payment_reference_type(i18n, payment_reference_type) {
		switch (payment_reference_type) {
			case Payment_Reference_Type.PRIMARY_INVOICE:
				return i18n.t('payment_reference_type.PRIMARY_INVOICE');
			case Payment_Reference_Type.ISO11649:
				return i18n.t('payment_reference_type.ISO11649');
			case Payment_Reference_Type.OGM:
				return i18n.t('payment_reference_type.OGM');
			case Payment_Reference_Type.PLAIN_ACCOUNT_ID:
				return i18n.t('payment_reference_type.PLAIN_ACCOUNT_ID');
			case Payment_Reference_Type.ACCOUNT_ID:
				return i18n.t('payment_reference_type.ACCOUNT_ID');
			default:
				return payment_reference_type;
		}
	}

	static period(i18n, value: Period) {
		switch (value) {
			case Period.MONTHLY:
				return i18n.t('period_enum.MONTHLY');
			case Period.BI_WEEKLY:
				return i18n.t('period_enum.BI_WEEKLY');
			case Period.WEEKLY:
				return i18n.t('period_enum.WEEKLY');
			case Period.YEARLY:
				return i18n.t('period_enum.YEARLY');
			default:
				return value;
		}
	}

	static legal_id_type(i18n, value) {
		switch (value) {
			case 'NRN':
				return i18n.t('legal_id_type.NRN');
			case 'VAT':
				return i18n.t('legal_id_type.VAT');
			case 'CRN_BE':
				return i18n.t('legal_id_type.CRN_BE');
			case 'ENTERPRISE_NUMBER':
				return i18n.t('legal_id_type.ENTERPRISE_NUMBER');
			case 'OTHER':
				return i18n.t('legal_id_type.OTHER');
			default:
				return value;
		}
	}

	static legal_id_type_description(i18n, value) {
		switch (value) {
			case 'NRN':
				return i18n.t('legal_id_type_description.NRN');
			case 'VAT':
				return i18n.t('legal_id_type_description.VAT');
			case 'CRN_BE':
			case 'ENTERPRISE_NUMBER':
				return i18n.t('legal_id_type_description.CRN_BE');
			case 'OTHER':
				return i18n.t('legal_id_type_description.OTHER');
			default:
				return value;
		}
	}

	static document_type(i18n, value) {
		switch (value) {
			case 'INVOICE':
				return i18n.t('document_type.INVOICE');
			case 'CREDIT_NOTE':
				return i18n.t('document_type.CREDIT_NOTE');
			case 'DEBIT_NOTE':
				return i18n.t('document_type.DEBIT_NOTE');
			case 'PAYMENT':
				return i18n.t('document_type.PAYMENT');
			default:
				return value;
		}
	}
}
